/* De Baron: alleen de menubalk sticky bij scrollen */
(function(){
  function init(){
    var nav=document.getElementById('main-nav');
    if(!nav) return;
    var placeholder=null, stuck=false, threshold=0;
    function measure(){ if(stuck) return; threshold=nav.getBoundingClientRect().top + (window.pageYOffset||document.documentElement.scrollTop); }
    function stick(){ if(stuck) return; placeholder=document.createElement('div'); placeholder.style.height=nav.offsetHeight+'px'; placeholder.setAttribute('data-baron-nav-placeholder',''); nav.parentNode.insertBefore(placeholder, nav.nextSibling); nav.classList.add('baron-nav-stuck'); stuck=true; }
    function unstick(){ if(!stuck) return; nav.classList.remove('baron-nav-stuck'); if(placeholder){placeholder.remove();placeholder=null;} stuck=false; }
    function onScroll(){ var y=window.pageYOffset||document.documentElement.scrollTop; if(!stuck && y>=threshold){stick();} else if(stuck && y<threshold){unstick();} }
    window.addEventListener('scroll', onScroll, {passive:true});
    window.addEventListener('resize', function(){ unstick(); measure(); onScroll(); });
    measure(); onScroll();
  }
  if(document.readyState!=='loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();
